import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'decodeUri'
})
@Injectable()
export class DecodeUriPipe implements PipeTransform {
  transform(url: string): string {
    return decodeURIComponent(url);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/replay/replay.pipe.ts